// Tabs of the country settings modal, in display order. "launch" comes first:
// it is the overview of everything a country still needs.

import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

export interface CountryModalTab {
  value: string;
  label: MessageDescriptor;
  icon: string;
}

export const COUNTRY_MODAL_TABS: readonly CountryModalTab[] = [
  { value: "launch", label: msg`Launch`, icon: "🚀" },
  { value: "general", label: msg`General`, icon: "🏠" },
  { value: "features", label: msg`Features`, icon: "⚡" },
  { value: "ai-profile", label: msg`AI Profile`, icon: "🤖" },
  { value: "messaging", label: msg`Messaging`, icon: "💬" },
  { value: "payments", label: msg`Payments`, icon: "💳" },
  { value: "health", label: msg`Health`, icon: "🏥" },
  { value: "founding", label: msg`Founding`, icon: "🌟" },
  { value: "referrals", label: msg`Referrals`, icon: "🤝" },
  { value: "legal", label: msg`Legal`, icon: "⚖️" },
  { value: "competitor", label: msg`Competitor`, icon: "⚔️" },
];

export const COUNTRY_MODAL_TAB_IDS: readonly string[] = COUNTRY_MODAL_TABS.map((t) => t.value);

export const DEFAULT_COUNTRY_MODAL_TAB = "launch";
